import { useState } from "react";
import CartView from "../components/cart/cart-view";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faShoppingBasket } from "@fortawesome/free-solid-svg-icons";

interface INavbarCart {
  cartItemsCount: number;
  showLabel?: boolean;
}

const NavbarCart = ({ cartItemsCount, showLabel = false }: INavbarCart) => {
  const [showCartView, setShowCartView] = useState(false);

  return (
    <div className={`position-relative ${showLabel ? "mobile-cart-item" : ""}`}>
      <button
        type="button"
        aria-label={`${cartItemsCount} items in cart`}
        onClick={() => setShowCartView(!showCartView)}
        id="linkCartView"
        className={showLabel ? "mobile-bottom-link" : "navbar-cart-button"}
      >
        <span className="mobile-nav-icon-wrap">
          <FontAwesomeIcon icon={faShoppingBasket} />
          <span className="mobile-cart-count">{cartItemsCount}</span>
        </span>
        {showLabel && <span>Cart</span>}
      </button>
      <CartView show={showCartView} setShowModal={setShowCartView} />
    </div>
  );
};

export default NavbarCart;
